import React from "react";
import { isEmpty, startCase } from "lodash";
import dayjs from "dayjs";
import { FaReply } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort } from "react-icons/bs";
import { AiFillEye } from "react-icons/ai";
import { supportSorting } from "utils/constants";
import helpers from "utils/helpers";

const Table = ({
  users,
  // getAllSupport,
  handleView,
  user,
  page,
  sort,
  setSort,
  handelReply,
  manager,
}) => {
  const { t } = useTranslation();

  const handleSortItem = (sortByValue, sortTypeValue) => {
    const newSortType = sort.sortType === "asc" ? "desc" : "asc";
    setSort({
      sortBy: sortByValue,
      sortType: sortByValue === sort.sortBy ? newSortType : sortTypeValue,
    });
  };

  return (
    <div className="p-3">
      <div className="overflow-x-auto relative rounded-lg border">
        <table className="w-full text-xs text-left text-[#6c6c6c] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-6">
                Sr no.
              </th>
              <th scope="col" className="py-3 px-6">
                {t("COMPANY_ID")}
              </th>
              <th scope="col" className="py-3 px-6">
                {t("COMPANY_NAME")}
              </th>
              {supportSorting.map((option) => (
                <th className="py-3 cursor-pointer px-6 " onClick={() => handleSortItem(option.sortBy, "asc")} key={option.sortBy} scope="col">
                  <div className="justify-start flex ">
                    <span>{option.displayText}</span>
                    <span>
                      {sort.sortBy === option.sortBy && sort.sortType === "asc" && <BsArrowUpShort className="h-4 w-4" />}
                      {sort.sortBy === option.sortBy && sort.sortType === "desc" && <BsArrowUpShort className="h-4 rotate-180 w-4 " />}
                    </span>
                  </div>
                </th>
              ))}

              <th scope="col" className="py-3 px-6">
                {t("Status")}
              </th>
              <th scope="col" className="py-3 px-6">
                {t("O_ACTION")}
              </th>
            </tr>
          </thead>
          <tbody>
            {users &&
              users?.map((item, i) => (
                <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
                    {i + 1 + 10 * (page - 1)}
                  </th>
                  <td className="py-4 px-6 border-r text-gray-900">{item?.companyID} </td>
                  <td className="py-4 px-6 border-r text-gray-900">{item?.name}</td>
                  <td className="py-4 px-6 border-r text-gray-900 text-left">{item?.email}</td>

                  <td className="py-4 px-6 border-r text-gray-900 text-left">{dayjs(item?.createdAt).format("MM-DD-YYYY hh:mm A")} </td>

                  <td className="py-4 px-6 border-r text-gray-900 text-left">{helpers.ternaryCondition(item?.adminReplyDate, dayjs(item?.adminReplyDate).format("MM-DD-YYYY hh:mm A"), "Not Replied")} </td>
                  <td className="py-4 px-6 border-r text-gray-900 text-left">{startCase(item?.status)}</td>
                  <td className="py-4 px-6 border-r text-gray-900 text-center">
                    <div className="">
                      <ul className="flex justify-center">
                        {user?.role === "admin" && (
                          <li disabled={item?.status == "replied" ? true : false} className={item?.status == "replied" ? "" : "px-2 py-2 hover:bg-white hover:text-LightBlue"} onClick={() => handelReply(item)}>
                            {item?.status == "replied" ? null : (
                              <a title={t("REPLY")} className="hover:text-blue-700 transition duration-150 ease-in-out" data-bs-toggle="tooltip">
                                {" "}
                                <FaReply className="cursor-pointer w-5 h-5 text-slate-600" />
                              </a>
                            )}
                          </li>
                        )}

                        {(manager?.view || user?.role === "admin") && (
                          <li onClick={() => handleView(item)} className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                            <a title="View support">
                              {" "}
                              <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />{" "}
                            </a>
                          </li>
                        )}
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            {isEmpty(users) ? (
              <tr className="bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700">
                <td className="py-4 px-6 border-r" colSpan={12}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
